import { render, staticRenderFns } from "./MonthlyPaymentsReceived.vue?vue&type=template&id=b33d58ec"
import script from "./MonthlyPaymentsReceived.vue?vue&type=script&lang=js"
export * from "./MonthlyPaymentsReceived.vue?vue&type=script&lang=js"
import style0 from "./MonthlyPaymentsReceived.vue?vue&type=style&index=0&id=b33d58ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports